export class AuthorizationError extends Error {}

export class BadRequestError extends Error {}

export class NetworkError extends Error {}

export class NotFoundError extends Error {}

export class PaymentRequiredError extends Error {}

export class OfflineError extends Error {}

export class ServiceUnavailableError extends Error {}

export class BadGatewayError extends Error {}

export class UnprocessableEntityError extends Error {}

export class RateLimitExceededError extends Error {}

export class RequestError extends Error {}

export class UpdateRequiredError extends Error {}
